import { t as tr } from './i18n';
import { fmtNum } from './format';
import type { ItemTerms, Offer, RfqItem } from './types';

/**
 * Condițiile de cantitate ale unui preț: „minim 100 de saci”, „se vinde doar la
 * palet de 40”. Ceri 80, plătești 100 — iar prețul unitar mai mic poate ieși
 * mai scump pe poziție decât al altuia fără minim.
 */

/** Condițiile unei poziții dintr-o ofertă; null dacă nu are niciuna. */
export function termsOf(offer: Offer, item: RfqItem): ItemTerms | null {
  const t = offer.terms?.[item.id];
  return t && (t.minQty != null || t.packSize != null) ? t : null;
}

/**
 * Cât plătești de fapt: cel puțin minimul, rotunjit în sus la ambalaj întreg.
 * Fără condiții, exact cantitatea cerută.
 */
export function billedQty(qty: number, terms: ItemTerms | null): number {
  if (!terms) return qty;
  let q = Math.max(qty, terms.minQty ?? 0);
  if (terms.packSize) {
    // toleranța acoperă zecimalele de calculator: 120 / 40 nu trebuie să dea 4 ambalaje
    q = Math.ceil(q / terms.packSize - 1e-9) * terms.packSize;
  }
  return Math.round(q * 10_000) / 10_000;
}

/** Condițiile, pe scurt: „minim 100 sac · câte 40 sac”. */
export function termsText(terms: ItemTerms, unit: string): string {
  const parts: string[] = [];
  if (terms.minQty != null) parts.push(tr('minim {0} {1}', fmtNum(terms.minQty), unit));
  if (terms.packSize != null) parts.push(tr('câte {0} {1}', fmtNum(terms.packSize), unit));
  return parts.join(' · ');
}

/** Avertizarea din celulă, doar când condițiile schimbă cantitatea plătită. */
export function termsWarning(item: RfqItem, terms: ItemTerms | null): string | null {
  if (!terms) return null;
  const billed = billedQty(item.qty, terms);
  if (billed <= item.qty) return null;
  return tr('{0}: plătești {1}, nu {2}', termsText(terms, item.unit), fmtNum(billed), fmtNum(item.qty));
}
